import { GET_SKID_DIMENSIONS } from '../actions/types';
export default function (state = false, action) {
    switch (action.type) {
        case GET_SKID_DIMENSIONS:
            return action.payload;

        default:
            return state;
    }
}